import { fromJS } from 'immutable';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { findMatchingSchema } from '../../util/discriminator';
import { parseRef } from '../../util/refs';
import DefaultContentPreview from './default-content-preview';

const emptyMap = fromJS({});
export default class ContentPreview extends PureComponent {
  static propTypes = {
    value: PropTypes.any.isRequired,
    schema: PropTypes.object.isRequired,
    formName: PropTypes.string.isRequired,
    forms: PropTypes.object.isRequired,
    path: PropTypes.string.isRequired,
    config: PropTypes.object.isRequired,
    resolveRef: PropTypes.func.isRequired,
    context: PropTypes.object,
    widgets: PropTypes.object,
    locale: PropTypes.string
  };

  render() {
    let { schema, config } = this.props;
    const { widgets, forms, resolveRef, value } = this.props;
    let Preview = DefaultContentPreview;

    schema = resolveRef(schema);
    if (schema.get('oneOf')) {
      const matchingSchema = findMatchingSchema(resolveRef, schema, value);
      if (matchingSchema) {
        schema = resolveRef(matchingSchema);
        const $ref = matchingSchema.get('$ref');
        if ($ref) {
          const { typeName } = parseRef($ref);
          config = config.get('order') ? config : forms?.getIn([typeName, 'default']);
        }
      }
    }

    const widgetName = config?.get('preview') ?? 'contentPreview';
    if (widgets?.[widgetName]) {
      Preview = widgets[widgetName];
    }

    return <Preview {...this.props} schema={schema} config={config ?? emptyMap} />;
  }
}
